import { useQuery } from "@tanstack/react-query";

import { useTRPC } from "@/integrations/trpc/react";

export function useStoreUrl() {
  const trpc = useTRPC();
  const { data } = useQuery(
    trpc.settings.get.queryOptions({ key: "store-link" }),
  );
  return data?.value && typeof data.value === "string" ? data.value : null;
}

// The rulebook URL lives only in the `rulebook-link` setting (seed it with
// src/db/fix/add-rulebook-link-setting.ts). No hardcoded fallback — when the
// setting is unset the link is simply not shown, so there is no default URL to
// drift out of sync. Admins change the value at /admin/settings.
export function useRulebookUrl() {
  const trpc = useTRPC();
  const { data } = useQuery(
    trpc.settings.get.queryOptions({ key: "rulebook-link" }),
  );
  return data?.value && typeof data.value === "string" ? data.value : null;
}
